export default function (_html /*you can put each single tag per argument*/) {
  var _tags: any = [],
    _tag = "";
  for (var _a = 1; _a < arguments.length; _a++) {
    _tag = arguments[_a].replace(/<|>/g, "").trim();
    if (arguments[_a].length > 0) _tags.push(_tag, "/" + _tag);
  }

  if (!(typeof _html == "string") && !(_html instanceof String)) return "";
  else if (_tags.length == 0) return _html.replace(/<(\s*\/?)[^>]+>/g, "");
  else {
    var _re = new RegExp("<(?!(" + _tags.join("|") + ")\s*\/?)[^>]+>", "g");
    return _html.replace(_re, "");
  }
}
